import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { SettingsState } from '@app/_state/settings.state';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { NzMessageService } from "ng-zorro-antd/message";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private store = inject(Store);
  private router = inject(Router);
  private message = inject(NzMessageService);


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.store.selectSnapshot(SettingsState.token);
    if (token) {
      const jwtHelper = new JwtHelperService();
      const isTokenExpired = jwtHelper.isTokenExpired(token);
      console.log(isTokenExpired);
      if (isTokenExpired) {
        this.router.navigate(['/logout']);
      }
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
      return next.handle(authReq).pipe(
        tap(
          event => {
            if (event instanceof HttpResponse) {
              console.log('Server response');
            }
          },
          err => {
            if (err instanceof HttpErrorResponse) {
              if (err.status == 401) {
                console.log('Unauthorized');
                this.router.navigate(['/logout']);
              } else if (err.status == 403) {
                this.message.error(`Доступ на запрашиваемую страницу запрещен: ${err?.message}`, {
                  nzDuration: 5000
                });
              }
            }
          }
        )
      );
    }
    return next.handle(req);
  }
}
